/* eslint-disable no-shadow */
export default class ClickZoom {
  constructor(element, options) {
    this.options = {
      url: null,
      callback: null,
      target: null,
      ...(options || {}),
    };

    this.clicked = false;
    this.element = element;
    this.target = this.options.target || element;
    this.source = element;

    this.img = new Image();
    this.img.classList.add('zoomImg');
    this.img.style.position = 'absolute';
    this.img.style.top = 0;
    this.img.style.left = 0;
    this.img.style.display = 'none';
    this.img.style.border = 'none';
    this.img.style.maxWidth = 'none';

    this.img.onload = () => this.onLoad();
    this.img.src = this.options.url;

    this.element.appendChild(this.img);
  }

  start(e) {
    this.outerWidth = this.target.offsetWidth;
    this.outerHeight = this.target.offsetHeight;
    this.xRatio = (this.img.width - this.outerWidth) / this.source.offsetWidth;
    this.yRatio = (this.img.height - this.outerHeight) / this.source.offsetHeight;

    const bounds = this.source.getBoundingClientRect();
    this.offset = {
      top: bounds.top + document.body.scrollTop,
      left: bounds.left + document.body.scrollLeft,
    };

    this.move(e);

    this.img.style.display = 'block';
  }

  stop() {
    this.img.style.display = 'none';
  }

  move(e) {
    let left = e.pageX - this.offset.left;
    let top = e.pageY - this.offset.top;

    top = Math.max(Math.min(top, this.outerHeight), 0);
    left = Math.max(Math.min(left, this.outerWidth), 0);

    this.img.style.left = `${left * -this.xRatio}px`;
    this.img.style.top = `${top * -this.yRatio}px`;
  }

  onClick(e) {
    // eslint-disable-next-line no-empty
    if (this.clicked) {} else {
      this.clicked = true;
      e.target.classList.add('move-cursor');
      e.target.classList.remove('zoom-cursor');

      this.start(e);

      const onMove = (e) => this.move(e);
      const onZoomOut = () => {
        e.target.classList.remove('move-cursor');
        e.target.classList.add('zoom-cursor');
        this.stop();
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('click', onZoomOut);
        this.clicked = false;
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('click', onZoomOut);

      if (e.stopPropagation) {
        e.stopPropagation();
      }

      return false;
    }
  }

  onLoad() {
    this.element.addEventListener('click', (e) => this.onClick(e));

    this.img.style.width = this.img.width;
    this.img.style.height = this.img.height;

    if (this.options.callback) {
      this.options.callback.call(this.img);
    }
  }
}
